import SimpleBar from 'simplebar';
import { isMobile } from '../utils/utilities';
import { lockBody, unlockBody } from '../utils/bodyLock';
let openBurgerMenuButtons;
let closeMenuButtons;
let burgerMenu;
let burgerMenuBackground;
let primaryMenu;
let primaryMenuItems;
let singleMenuItems;
let secondaryMenus;
let buttonBack;
let primaryBar;
let secondaryBars;
let shopButton;
let exploreButton;
let shopWindow;
let exploreWindow;
let acordionTrigger;
let acordionCollectionContent;
const onAccordionTrigger = () => {
    acordionTrigger.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            let accordionRelatedContent = trigger.nextElementSibling;
            if (accordionRelatedContent === null) {
                return;
            }
            if (accordionRelatedContent.getAttribute('aria-hidden') === 'true') {
                trigger.setAttribute('aria-expanded', 'true');
                accordionRelatedContent.setAttribute('aria-hidden', 'false');
            }
            else {
                trigger.setAttribute('aria-expanded', 'false');
                accordionRelatedContent.setAttribute('aria-hidden', 'true');
            }
        });
    });
};
const onTabClick = () => {
    // Set initial state
    shopButton.setAttribute('aria-selected', 'true');
    exploreButton.setAttribute('aria-selected', 'false');
    // Add click handler
    exploreButton.addEventListener('click', () => {
        const isShopActive = shopButton.getAttribute('aria-selected') === 'true';
        shopButton.setAttribute('aria-selected', (!isShopActive).toString());
        exploreButton.setAttribute('aria-selected', isShopActive.toString());
        shopWindow.setAttribute('aria-hidden', true);
        exploreWindow.setAttribute('aria-hidden', false);
    });
    shopButton.addEventListener('click', () => {
        const isExploreActive = exploreButton.getAttribute('aria-selected') === 'true';
        exploreButton.setAttribute('aria-selected', (!isExploreActive).toString());
        shopButton.setAttribute('aria-selected', isExploreActive.toString());
        shopWindow.setAttribute('aria-hidden', false);
        exploreWindow.setAttribute('aria-hidden', true);
    });
};
const openBurgerMenu = () => {
    lockBody();
    document.documentElement.classList.add('burger-menu--is-open');
    burgerMenu.classList.add('burger-menu--open');
    if (!primaryBar) {
        primaryBar = new SimpleBar(primaryMenu);
    }
    else {
        primaryMenu.querySelector('.simplebar-content-wrapper').scrollTop = 0;
    }
};
// Remove the active class from the selected item in the primary menu
const resetActivePrimaryMenuItems = () => {
    const currentActive = [...primaryMenuItems].find((item) => {
        return item.classList.contains('active');
    });
    if (currentActive) {
        currentActive.classList.remove('active');
    }
};
const resetActiveSecondaryMenu = () => {
    burgerMenu.classList.remove('burger-menu--secondary');
    if (secondaryMenus) {
        const currentActive = [...secondaryMenus].find((item) => {
            return item.classList.contains('active');
        });
        if (currentActive) {
            currentActive.classList.remove('active');
        }
    }
};
// Remove any active classes from the primary menu
const resetActivePrimaryMenu = () => {
    resetActivePrimaryMenuItems();
    primaryMenu.classList.remove('active');
};
const openSecondaryMenu = (primaryMenuItem) => {
    const secondaryMenuID = primaryMenuItem.dataset.menuItem;
    primaryMenu.classList.add('active');
    // Clear any active items
    resetActivePrimaryMenuItems();
    primaryMenuItem.classList.add('active');
    if (secondaryMenus) {
        resetActiveSecondaryMenu();
        burgerMenu.classList.add('burger-menu--secondary');
        const foundSecondaryMenuItem = [...secondaryMenus].find((secondaryMenuItem) => {
            return secondaryMenuItem.dataset.menuSecondary === secondaryMenuID;
        });
        if (foundSecondaryMenuItem) {
            foundSecondaryMenuItem.classList.add('active');
            if (!secondaryBars[secondaryMenuID]) {
                secondaryBars[secondaryMenuID] = new SimpleBar(foundSecondaryMenuItem.querySelector('[data-simplebar]'));
            }
            else {
                // Scroll to top submenu
                foundSecondaryMenuItem.querySelector(' .simplebar-content-wrapper').scrollTop = 0;
            }
        }
    }
};
const closeBurgerMenu = () => {
    unlockBody();
    // Close the current active seconvary menu
    if (burgerMenu) {
        resetActiveSecondaryMenu();
        resetActivePrimaryMenu();
        document.documentElement.classList.remove('burger-menu--is-open');
        burgerMenu.classList.remove('burger-menu--open');
    }
};
const onClickPrimaryMenuItem = (event, primaryMenuItem) => {
    if (isMobile || window.innerWidth <= 768) {
        event.preventDefault();
        openSecondaryMenu(primaryMenuItem);
        return false;
    }
};
const onHoverPrimaryMenuItem = (primaryMenuItem) => {
    if (!isMobile && window.innerWidth > 768) {
        openSecondaryMenu(primaryMenuItem);
    }
};
const addEventListeners = () => {
    // Add click event to background
    if (burgerMenuBackground) {
        burgerMenuBackground.addEventListener('click', closeBurgerMenu);
    }
    // Add click event to any button that opens the menu
    if (openBurgerMenuButtons.length > 0) {
        [...openBurgerMenuButtons].forEach((button) => {
            button.addEventListener('click', openBurgerMenu);
        });
    }
    // Add click event to any button that closes the menu
    if (closeMenuButtons.length > 0) {
        [...closeMenuButtons].forEach((button) => {
            button.addEventListener('click', closeBurgerMenu);
        });
    }
    // Add events to the back button on the secondary menu (This button appears on mobile and tablet)
    if (buttonBack.length > 0) {
        [...buttonBack].forEach((button) => {
            button.addEventListener('click', () => {
                resetActiveSecondaryMenu();
                resetActivePrimaryMenu();
            });
        });
    }
    // Add listeners to links in primary menu
    /*
    if ((primaryMenuItems && primaryMenuItems.length > 0) || (singleMenuItems && singleMenuItems.length > 0)) {
      [...primaryMenuItems].forEach((item: HTMLLIElement) => {
        const link = item.querySelector('a');
        link.addEventListener('mouseover', () => {
          onHoverPrimaryMenuItem(item);
        });
        link.addEventListener('click', (event) => {
          onClickPrimaryMenuItem(event, item);
        });
      });
  
      [...singleMenuItems].forEach((item: HTMLLIElement) => {
        const link = item.querySelector('a');
        link.addEventListener('mouseover', () => {
          resetActiveSecondaryMenu();
          resetActivePrimaryMenu();
        });
        link.addEventListener('click', () => {
          resetActiveSecondaryMenu();
          resetActivePrimaryMenu();
        });
      });
    }
      */
};
const init = () => {
    openBurgerMenuButtons = document.querySelectorAll('[data-menu-open]');
    closeMenuButtons = document.querySelectorAll('[data-menu-close]');
    buttonBack = document.querySelectorAll('[data-menu-button-back]');
    primaryMenu = document.querySelector('[data-menu-primary]');
    primaryMenuItems = (primaryMenu === null || primaryMenu === void 0 ? void 0 : primaryMenu.querySelectorAll('[data-menu-item]')) || null;
    singleMenuItems = (primaryMenu === null || primaryMenu === void 0 ? void 0 : primaryMenu.querySelectorAll('[data-menu-item-single]')) || null;
    secondaryMenus = document.querySelectorAll('[data-menu-secondary]');
    burgerMenuBackground = document.querySelector('[data-menu-bg]');
    burgerMenu = document.querySelector('[data-burger-menu]');
    [shopButton, exploreButton] = document.querySelectorAll('.tabsTrigger');
    [shopWindow, exploreWindow] = document.querySelectorAll('.tabsContent');
    acordionTrigger = document.querySelectorAll('.accordion-trigger');
    acordionCollectionContent = document.querySelectorAll('.accordion-content');
    secondaryBars = {};
    // Pages without the burger menu (e.g. the password page) would otherwise throw here and
    // stop the rest of theme.js, leaving the page hidden behind the loading state
    if (!burgerMenu)
        return;
    addEventListeners();
    if (shopButton && exploreButton)
        onTabClick();
    onAccordionTrigger();
};
export default {
    init,
    open: openBurgerMenu,
    close: closeBurgerMenu,
    tab: onTabClick,
};
